import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';
import { DirectionKindEnum } from '@zaoblako/shared/modules/catalog/enums/direction.kind.enum';

/**
 * Localized human-readable string representations of {@link DirectionKindEnum} enumeration values
 */
export const DirectionKindEnumI18n: Record<I18nLocalesEnum, Record<DirectionKindEnum, string>> = {
  [I18nLocalesEnum.RU_RU]: {
    [DirectionKindEnum.INCOME]: 'Доходы',
    [DirectionKindEnum.EXPENSE]: 'Расходы',
    [DirectionKindEnum.INCOME_TAX]: 'Налог на прибыль',
    [DirectionKindEnum.DIVIDENTS]: 'Дивиденды',
  },
  [I18nLocalesEnum.EN_US]: {
    [DirectionKindEnum.INCOME]: 'Incomes',
    [DirectionKindEnum.EXPENSE]: 'Expenses',
    [DirectionKindEnum.INCOME_TAX]: 'Income taxes',
    [DirectionKindEnum.DIVIDENTS]: 'Dividents',
  },
};
